import React from 'react';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import Input from 'component/atom/forms/input/input/Input';
import UploadFile from 'component/atom/forms/upload-file/UploadFile';
import styles from './ImageForm.module.scss';
import Button from 'component/atom/forms/button/Button';
import fileToBase64 from 'helpers/fileToBase64';
const ImageForm = ({
  formik,
  allowedExtensions,
  title,
  node,
  onClose,
  isError,
}) => {
  const handleChange = () => {
    if (!formik.values.isURL) {
      formik.setFieldValue('uploadedFile', '');
      formik.setFieldValue('file.fileName', '');
      formik.setFieldValue('file.contentType', '');
      formik.setFieldValue('file.fileContent', '');
    } else {
      formik.setFieldValue('url', '');
    }
    formik.setFieldValue('isURL', !formik.values.isURL);
  };

  const fileToBinary = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) {
        reject('No file provided');
        return;
      }

      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        resolve({
          fileName: file.name,
          contentType: file.type,
          fileContent: new Uint8Array(reader.result),
        });
      };
      reader.onerror = (error) => reject('Error reading file: ' + error);
    });
  };

  return (
    <form
      className='formCont'
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      {/* <div>
        <RadioGroup
          name="uploadOrUrl"
          selectedValue={formik.values.isURL}
          onChange={handleChange}
          options={[
            { value: false, label: 'Upload' },
            { value: true, label: 'Add URL' },
          ]}
        />
      </div> */}

      <>
        {formik.values.url || formik.values.uploadedFile ? (
          <div className={styles.imageCont}>
            {title == 'Video' ? (
              <video autoPlay loop muted id={styles['video']}>
                <source
                  src={
                    formik.values.uploadedFile
                      ? URL.createObjectURL(formik.values.uploadedFile)
                      : formik.values.url
                  }
                  type='video/mp4'
                />
              </video>
            ) : (
              <img
                src={
                  formik.values.uploadedFile != ''
                    ? URL.createObjectURL(formik.values.uploadedFile)
                    : formik.values.url
                }
                alt='image'
                className={styles.image}
              />
            )}
            <div className={styles['content-image']}>
              <Button
                label='Remove'
                variant='danger-rev'
                type='delete'
                onClick={() => {
                  formik.setFieldValue('uploadedFile', '');
                  formik.setFieldValue('file.fileName', '');
                  formik.setFieldValue('file.contentType', '');
                  formik.setFieldValue('file.fileContent', '');
                  formik.setFieldValue('url', '');
                }}
              />
            </div>
          </div>
        ) : (
          <UploadFile
            type={title}
            title={`Upload ${title}`}
            value={formik.values.file.fileName}
            name='file'
            onChange={async (event) => {
              const file = event.target.value;
              if (!file) return;
              formik.setFieldValue('uploadedFile', file);
              try {
                const fileData = await fileToBase64(file);
                formik.setFieldValue('file', fileData);
                formik.setFieldValue('url', '');
              } catch (error) {
                console.error('File processing error:', error);
              }
            }}
            onBlur={formik.handleBlur}
            error={
              formik.touched.file?.fileName && formik.errors.file?.fileName
            }
            touched={formik.touched.file?.fileName}
            allowedExtensions={allowedExtensions}
          />
        )}
      </>

      {/* <Input
          name="url"
          placeholder="Enter URL"
          value={formik.values.url}
          onChange={(e) => {
            formik.setFieldValue('url', e.target.value);
          }}
          onBlur={formik.handleBlur}
          error={formik.touched.url && formik.errors.url}
        /> */}

      {/* <div className="footer">
        <Button
          label="Cancel"
          variant="#B3B5BD"
          transparent
          onClick={onClose}
        />

        <Button label="Save" onClick={formik.handleSubmit} />
      </div> */}
    </form>
  );
};

export default ImageForm;
